import { z } from 'zod';
import type { GetCardPositionDto } from '../types/GetCardPositionDto';

export const getCardPositionDtoSchema = z.object({
  id: z.string().uuid(),
  position: z.number().int().min(1),
}) as z.ZodType<GetCardPositionDto>;
